import { InteractionRequiredAuthError, IPublicClientApplication } from "@azure/msal-browser";

export const acquireTokenWithConsent = async (instance: IPublicClientApplication, instanceUrl: string) => {
    const request = {
        scopes: [`${instanceUrl}/.default`],
        account: instance.getActiveAccount() ?? undefined, // Ensure account is undefined if null
        prompt: "consent"
    };

    let instanceToken;
    try {
        const tokenResponse = await instance.acquireTokenSilent(request);
        instanceToken = tokenResponse.accessToken;
    } catch (error) {
        if (error instanceof InteractionRequiredAuthError) {
            const tokenResponse = await instance.acquireTokenPopup(request);
            instanceToken = tokenResponse.accessToken;
        } else {
            throw error;
        }
    }
    return instanceToken;
}